export const WORDPRESS_TIMEZONE =
  process.env.NEXT_PUBLIC_WORDPRESS_TIMEZONE || "America/Los_Angeles";
export const WORDPRESS_TIMEZONE_NAME = process.env.NEXT_PUBLIC_WORDPRESS_TIMEZONE_NAME || "Pacific";
export const SECONDARY_TIMEZONE = process.env.NEXT_PUBLIC_SECONDARY_TIMEZONE || "America/New_York";
export const SECONDARY_TIMEZONE_NAME = process.env.NEXT_PUBLIC_SECONDARY_TIMEZONE_NAME || "Eastern";
